import { render, staticRenderFns } from "./DashVue.vue?vue&type=template&id=5b21509e&scoped=true&"
import script from "./DashVue.vue?vue&type=script&lang=js&"
export * from "./DashVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b21509e",
  null
  
)

export default component.exports